// 프로젝트/연결 역할 공용 라벨 정의

export const STATUSES = [
  ["CONTACT", "컨택"],
  ["PLAN", "계획"],
  ["ONGOING", "진행"],
  ["DONE", "완료"],
  ["HOLD", "보류"],
];
export const STATUS_LABEL = Object.fromEntries(STATUSES);
export const STATUS_CLASS = {
  CONTACT: "sstoa-tag--gray",
  PLAN: "sstoa-tag--gray",
  ONGOING: "",
  DONE: "sstoa-tag--gray",
  HOLD: "sstoa-tag--gray",
};

export const ROLES = [
  ["CLIENT", "발주처(고객)"],
  ["SUPPLIER", "공급사(매입)"],
  ["SUBCONTRACTOR", "하도급"],
  ["PARTNER", "협력사"],
];
export const ROLE_LABEL = Object.fromEntries(ROLES);

export const COMPANY_TYPE_LABEL = {
  CUSTOMER: "고객사",
  VENDOR: "매입처",
  PARTNER: "협력사",
  FREELANCER: "프리랜서",
  GOV: "기관",
  INTERNAL: "내부",
};

export const TASK_STATUSES = [
  ["TODO", "할 일"],
  ["DOING", "진행"],
  ["DONE", "완료"],
];
export const TASK_STATUS_LABEL = Object.fromEntries(TASK_STATUSES);

export const ISSUE_STATUSES = [
  ["OPEN", "열림"],
  ["RESOLVED", "해결"],
];
export const ISSUE_STATUS_LABEL = Object.fromEntries(ISSUE_STATUSES);

export const PRIORITIES = [
  ["LOW", "낮음"],
  ["NORMAL", "보통"],
  ["HIGH", "높음"],
];
export const PRIORITY_LABEL = Object.fromEntries(PRIORITIES);
export const PRIORITY_CLASS = { HIGH: "", NORMAL: "sstoa-tag--gray", LOW: "sstoa-tag--gray" };
